import vdo from "../assets/vdo/impser.webm";
import migration from "../assets/vdo/migration.webm";
import resi from "../assets/vdo/residence.webm";
import business from "../assets/vdo/businessbuy.webm";
import real from "../assets/vdo/relaste.webm";
import cons from "../assets/vdo/consulting.webm";
import reloac from "../assets/vdo/relocation.webm";
import aboard from "../assets/vdo/work.webm";
import property from "../assets/vdo/property.webm";
import medi from "../assets/vdo/medi.webm";

export const serviceData = [
  {
    id: "import-export-services",
    seoTitle: "Comprehensive Import/Export Services | PG Overseas Services",
    metaDescription:
      "Navigate global trade complexities with our expert import/export services. We handle regulations, partners, logistics, and more.",
    title: "Import/Export Services",
    vdo: vdo,
    mainContent: `
        At PG Overseas Services, we understand that international trade involves navigating complex
        regulations, finding reliable partners, and managing intricate logistics. Our comprehensive
        import/export services are designed to eliminate these challenges, allowing you to focus on your
        core business while we handle the complexities of global trade.
        `,
    featuresTitle: "Our Import/Export Services Include:",
    features: [
      "Regulatory Compliance Management: Navigate customs regulations, trade agreements, and documentation requirements with ease",
      "Partner Identification: Connect with verified suppliers, distributors, and logistics providers worldwide",
      "Supply Chain Optimization: Streamline your global supply chain for maximum efficiency and cost-effectiveness",
      "Trade Finance Solutions: Access competitive financing options for your international transactions",
      "Risk Management: Identify and mitigate risks associated with international trade",
    ],
    whyChooseTitle: "Why Choose Our Import/Export Services?",
    whyChoosePoints: [
      "Global Network: Access our extensive network of verified international partners",
      "Compliance Expertise: Stay updated with changing international trade regulations",
      "Cost Optimization: Reduce operational costs through efficient trade practices",
      "End-to-End Support: Receive comprehensive assistance from initial planning to execution",
    ],
    testimonial: {
      author: "Rajesh Mehta",
      designation: "CEO, Sunshine Textiles Ltd.",
      quote: `
          "PG Overseas Services transformed our approach to international trade. Their expertise helped us
          navigate complex regulations and find reliable suppliers in Southeast Asia, resulting in a 30%
          reduction in procurement costs and zero compliance issues. Their team's dedication to our success
          has made them an invaluable partner for our business expansion."
        `,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      {
        label: "Company Name*",
        type: "text",
        name: "companyName",
        required: true,
      },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Country of Interest*",
        type: "text",
        name: "country",
        required: true,
      },
      {
        label: "Import/Export Requirements*",
        type: "select",
        name: "requirements",
        required: true,
        options: [
          { label: "Raw Materials", value: 1 },
          { label: "Finished Products", value: 2 },
          { label: "Services", value: 3 },
          { label: "Other", value: 4 },
        ],
      },
      {
        label: "Brief Description of Your Requirements*",
        type: "textarea",
        name: "description",
        required: true,
      },
      {
        label: "How did you hear about us?",
        type: "text",
        name: "hearAboutUs",
      },
      {
        label: "Preferred Contact Method",
        type: "select",
        name: "contactMethod",
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "migration-services",
    seoTitle:
      "Professional Migration Services | Visa & Immigration Experts | PG Overseas Services",
    metaDescription:
      "Get expert advice on education visas, skilled visas, work permits, PR and residencies worldwide from registered migration agents, lawyers, and accountants.",
    title: "Migration Services",
    vdo: migration,
    mainContent: `
        At PG Overseas Services, we understand that relocating to a new country is a life-changing decision.
        Our comprehensive migration services connect you with registered migration agents, qualified
        lawyers, and experienced accountants to ensure your transition is smooth and successful.
        `,
    featuresTitle: "Our Migration Services Include:",
    features: [
      "Education Visas: Expert guidance for students pursuing international education",
      "Skilled Migration: Tailored solutions for professionals seeking work opportunities abroad",
      "Work Permits: Comprehensive assistance with employment visa applications and renewals",
      "Permanent Residency: Strategic advice on PR pathways for various countries",
      "Specialized Immigration Pathways: Custom solutions for entrepreneurs, investors, and specialized professionals",
    ],
    whyChooseTitle: "Why Choose Our Migration Services?",
    whyChoosePoints: [
      "Registered Professionals: Work with certified migration agents and legal experts",
      "Global Coverage: Solutions for migration to virtually any country worldwide",
      "Personalized Approach: Tailored strategies based on your unique circumstances",
      "Complete Documentation Support: Assistance with preparation and submission of all required paperwork",
      "Post-Migration Support: Services to help you settle in your new country",
    ],
    testimonial: {
      author: "Ananya Sharma",
      designation: "Software Engineer",
      quote: `
          "The team at PG Overseas Services guided me through every step of my skilled migration to Canada.
          Their attention to detail and deep knowledge of immigration policies helped me secure PR status
          much faster than I expected. Their support continued even after I arrived, helping me settle into my
          new life with confidence."
        `,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Country of Residence*",
        type: "text",
        name: "currentCountry",
        required: true,
      },
      {
        label: "Target Country/Countries*",
        type: "text",
        name: "targetCountry",
        required: true,
      },
      {
        label: "Type of Visa/Migration*",
        type: "select",
        name: "visaType",
        required: true,
        options: [
          { label: "Education", value: 1 },
          { label: "Skilled Work", value: 2 },
          { label: "Business", value: 3 },
          { label: "Family", value: 4 },
          { label: "Investor", value: 5 },
          { label: "Other", value: 6 },
        ],
      },
      {
        label: "Timeline for Migration*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Brief Description of Your Situation*",
        type: "textarea",
        name: "description",
        required: true,
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "residency-by-investment",
    seoTitle:
      "Residency by Investment Programs | Second Passport Services | PG Overseas Services",
    metaDescription:
      "Secure your second passport through strategic investments. Our experts guide you through residency and citizenship by investment programs worldwide.",
    title: "Residency by Investment",
    vdo: resi,
    mainContent: `
        In today's interconnected world, having a second passport or residency opens doors to
        unprecedented opportunities. PG Overseas Services specializes in guiding high-net-worth individuals
        through residency and citizenship by investment programs, ensuring both personal freedom and
        financial security.
        `,
    featuresTitle: "Our Residency by Investment Services Include:",
    features: [
      "Investment Program Consultation: Expert analysis of global citizenship programs to find your best match",
      "Investment Strategy Development: Guidance on optimal investment options for citizenship acquisition",
      "Complete Application Management: End-to-end assistance with all documentation and submissions",
      "Legal Compliance: Ensuring all investments and applications meet regulatory requirements",
      "Family Inclusion Planning: Strategies to extend benefits to family members",
      "Portfolio Management: Ongoing supervision of investment performance (where applicable)",
    ],
    whyChooseTitle: "Why Choose Our Residency by Investment Services?",
    whyChoosePoints: [
      "Global Program Knowledge: Expertise across Caribbean, European, and Asia-Pacific citizenship programs",
      "Investment Security: Due diligence on all investment options to ensure safety and appreciation",
      "Expedited Processing: Strategies to obtain your second passport in the shortest possible timeframe",
      "Confidentiality: Strict privacy protocols throughout the application process",
      "Post-Citizenship Support: Assistance with banking, property acquisition, and settlement",
    ],
    testimonial: {
      author: "Vikram Malhotra",
      designation: "Business Owner",
      quote: `
          "PG Overseas Services transformed what seemed like an overwhelming process into a
          straightforward journey. Their team's expertise in the Portugal Golden Visa program helped me make
          a sound real estate investment while securing EU residency for my family. Their attention to detail
          ensured our application was approved without any delays."
        `,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Citizenship(s)*",
        type: "text",
        name: "citizenship",
        required: true,
      },
      {
        label: "Investment Budget Range*",
        type: "select",
        name: "budget",
        required: true,
        options: [
          { label: "Under $100,000", value: 1 },
          { label: "$100,000 - $500,000", value: 2 },
          { label: "$500,000 - $1,000,000", value: 3 },
          { label: "$1,000,000+", value: 4 },
          { label: "Other", value: 5 },
        ],
      },
      {
        label: "Countries of Interest*",
        type: "text",
        name: "countriesOfInterest",
        required: true,
      },
      {
        label: "Investment Preferences*",
        type: "select",
        name: "investmentPreference",
        required: true,
        options: [
          { label: "Real Estate", value: 1 },
          { label: "Government Bonds", value: 2 },
          { label: "Business Investment", value: 3 },
          { label: "Donation", value: 4 },
        ],
      },
      {
        label: "Timeline Expectations*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Family Members to Include*",
        type: "number",
        name: "familyMembers",
        required: true,
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "business-buy-sale-services",
    seoTitle:
      "Global Business Buy & Sale Services | Cross-Border Business Acquisition | PG Overseas Services",
    metaDescription:
      "Expert guidance for buying or selling businesses internationally. We help identify opportunities, find the right partners, and navigate complex regulations worldwide.",
    title: "Business Buy/Sale Services",
    vdo: business,
    mainContent: `
        Every market offers unique opportunities for business growth and investment. At PG Overseas
        Services, we help entrepreneurs and investors identify the optimal regions for their business
        concepts, connect with suitable buyers or sellers, and navigate the complexities of international
        business transactions.
        `,
    featuresTitle: "Our Business Buy/Sale Services Include:",
    features: [
      "Market Opportunity Analysis: Identifying regions where your business concept will thrive",
      "Business Valuation: Expert assessment of business worth across different markets",
      "Buyer/Seller Identification: Connecting with pre-screened, serious parties",
      "Due Diligence Support: Thorough investigation of business operations, finances, and legal status",
      "Transaction Structuring: Developing optimal deal structures for international business sales",
      "Regulatory Navigation: Guidance through complex cross-border business regulations",
      "Post-Transaction Support: Assistance with business integration and operational transition",
    ],
    whyChooseTitle: "Why Choose Our Business Buy/Sale Services?",
    whyChoosePoints: [
      "Global Market Intelligence: Insight into business climates across diverse economies",
      "Established Network: Access to serious buyers and sellers worldwide",
      "Cross-Cultural Expertise: Navigate business practices and negotiation styles across cultures",
      "Legal and Regulatory Knowledge: Comprehensive understanding of international business laws",
      "Confidentiality: Strict protocols to protect sensitive business information",
    ],
    testimonial: {
      author: "Sunil Kapoor",
      designation: "CEO, Innovative Solutions Ltd.",
      quote: `
          "When I decided to expand by acquiring a manufacturing facility in Indonesia, PG Overseas Services
          provided invaluable guidance. They identified an ideal business that aligned perfectly with my
          expansion strategy, conducted thorough due diligence, and helped navigate the complex regulatory
          environment. The acquisition has increased our production capacity by 40% at a fraction of what it
          would have cost in our home market."
        `,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      {
        label: "Company Name (if applicable)",
        type: "text",
        name: "companyName",
      },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Interest*",
        type: "select",
        name: "interest",
        required: true,
        options: [
          { label: "Buying a Business", value: 1 },
          { label: "Selling a Business", value: 2 },
        ],
      },
      {
        label: "Industry Sector*",
        type: "text",
        name: "industry",
        required: true,
      },
      {
        label: "Target Countries/Regions*",
        type: "text",
        name: "targetCountries",
        required: true,
      },
      {
        label: "Business Size/Investment Range*",
        type: "text",
        name: "sizeOrBudget",
        required: true,
      },
      {
        label: "Timeline for Transaction*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Brief Description of Business Requirements*",
        type: "textarea",
        name: "description",
        required: true,
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "real-estate",
    seoTitle:
      "Global Real Estate Services | International Property Solutions | PG Overseas Services",
    metaDescription:
      "Comprehensive real estate services worldwide. Buy, sell, rent, or lease residential and commercial properties with expert guidance on documentation, negotiation, and management.",
    title: "Real Estate",
    vdo: real,
    mainContent: `
        Your Global Property Partner
        Whether you're looking to invest in international real estate, relocate your residence, or establish a
        business presence abroad, PG Overseas Services offers end-to-end real estate solutions across the
        globe. From property identification to ongoing management, we handle every aspect of your
        international real estate journey.
        `,
    featuresTitle: "Our Real Estate Services Include:",
    features: [
      "Property Identification: Finding properties that match your specific requirements",
      "Market Analysis: Providing insights on property values and investment potential",
      "Document Verification: Thorough examination of property titles and legal documentation",
      "Negotiation Support: Expert representation during price and terms negotiations",
      "Legal Compliance: Navigation of local real estate laws and regulations",
      "Property Inspection: Comprehensive physical verification of property condition",
      "Ongoing Management: Complete property maintenance, tenant relations, and rental collection",
    ],
    whyChooseTitle: "Why Choose Our Real Estate Services?",
    whyChoosePoints: [
      "Global Coverage: Property solutions in virtually any country",
      "Local Expertise: Network of on-ground real estate professionals",
      "Investment Insight: Data-driven advice on property appreciation potential",
      "Comprehensive Management: End-to-end solutions from acquisition to maintenance",
      "Trusted Network: Access to verified property agents, lawyers, and inspectors worldwide",
    ],
    testimonial: {
      author: "Meera and Rajiv Patel",
      designation: "Property Investors",
      quote: `"PG Overseas Services made purchasing a vacation home in Spain completely stress-free. They found
            exactly what we were looking for within our budget, handled all document verifications, and
            negotiated a price well below our maximum. Their property management team now handles
            everything while we're away, giving us true peace of mind about our investment."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Service Required",
        type: "select",
        name: "serviceRequired",
        options: [
          { label: "Buy", value: 1 },
          { label: "Sell", value: 2 },
          { label: "Rent", value: 3 },
          { label: "Lease", value: 4 },
          { label: "Property Management", value: 5 },
        ],
        required: true,
      },
      {
        label: "Property Type",
        type: "select",
        name: "propertyType",
        options: [
          { label: "Residential", value: 1 },
          { label: "Commercial", value: 2 },
          { label: "Industrial", value: 3 },
          { label: "Agricultural", value: 4 },
          { label: "Specialized", value: 5 },
          { label: "Development Land", value: 6 },
        ],
        required: true,
      },
      {
        label: "Location/Country of Interest*",
        type: "text",
        name: "location",
        required: true,
      },
      { label: "Budget Range*", type: "text", name: "budget", required: true },
      {
        label: "Property Requirements (size, features, etc.)*",
        type: "text",
        name: "requirements",
        required: true,
      },
      { label: "Timeline*", type: "text", name: "timeline", required: true },
      {
        label: "Investment Purpose (Personal Use, Investment, Business)*",
        type: "text",
        name: "purpose",
        required: true,
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "consulting-services",
    seoTitle:
      "Professional Business Consulting Services | Global Management Solutions | PG Overseas Services",
    metaDescription:
      "Comprehensive business and management consulting for companies of all sizes. Expert solutions for business challenges, growth strategies, and operational optimization.",
    title: "Business/Management Consulting",
    vdo: cons,
    mainContent: `
        Transformative Business Solutions
        In today's complex global business environment, having the right strategic guidance can make the
        difference between stagnation and exponential growth. PG Overseas Services offers comprehensive
        business and management consulting services designed to address your most pressing challenges
        and unlock new opportunities for success.
        `,
    featuresTitle: "Our Business Consulting Services Include:",
    features: [
      "Strategic Planning: Developing robust business strategies aligned with your vision",
      "Market Entry Planning: Crafting effective approaches to new geographic or product markets",
      "Operational Optimization: Streamlining processes for maximum efficiency and profitability",
      "Financial Analysis: Comprehensive assessment of financial health and improvement opportunities",
      "Organizational Development: Building effective team structures and leadership capabilities",
      "Crisis Management: Expert guidance through business challenges and unforeseen disruptions",
      "Digital Transformation: Strategies to leverage technology for business advantage",
    ],
    whyChooseTitle: "Why Choose Our Business Consulting Services?",
    whyChoosePoints: [
      "Cross-Industry Expertise: Experience across diverse business sectors",
      "Global Perspective: International business knowledge with local market understanding",
      "Customized Solutions: Tailored approaches rather than one-size-fits-all recommendations",
      "Implementation Support: Practical assistance beyond strategic advice",
      "Measurable Results: Focus on tangible business outcomes and ROI",
    ],
    testimonial: {
      author: "Amit Joshi",
      designation: "Managing Director, Global Innovations",
      quote: `"The business consulting team at PG Overseas Services completely transformed our approach to
            international expansion. Their market analysis identified opportunities we hadn't considered, and
            their operational guidance helped us establish efficient processes from day one. Within six months of
            implementing their recommendations, we saw a 35% increase in revenue and significantly improved
            profit margins."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      {
        label: "Company Name*",
        type: "text",
        name: "companyName",
        required: true,
      },
      {
        label: "Position/Title*",
        type: "text",
        name: "position",
        required: true,
      },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Industry Sector*",
        type: "text",
        name: "industry",
        required: true,
      },
      {
        label: "Company Size",
        type: "select",
        name: "companySize",
        options: [
          { label: "1-10", value: 1 },
          { label: "11-50", value: 2 },
          { label: "51-200", value: 3 },
          { label: "201-500", value: 4 },
          { label: "501+", value: 5 },
        ],
        required: true,
      },
      {
        label: "Primary Business Challenge*",
        type: "text",
        name: "challenge",
        required: true,
      },
      {
        label: "Consulting Area",
        type: "select",
        name: "consultingArea",
        options: [
          { label: "Strategy", value: 1 },
          { label: "Operations", value: 2 },
          { label: "Finance", value: 3 },
          { label: "Market Entry", value: 4 },
          { label: "Digital Transformation", value: 5 },
          { label: "Other", value: 6 },
        ],
        required: true,
      },
      {
        label: "Project Timeline*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Brief Description of Consulting Needs*",
        type: "textarea",
        name: "description",
        required: true,
      },
      {
        label: "How did you hear about us?",
        type: "text",
        name: "hearAboutUs",
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "relocation-in-india",
    seoTitle:
      "Expat Relocation Services India | Settle in India Assistance | PG Overseas Services",
    metaDescription:
      "Comprehensive relocation services for expats moving to India. Expert assistance with housing, schools, staff verification, and complete settlement solutions.",
    title: "Relocation Support",
    vdo: reloac,
    mainContent: `
        Your Smooth Transition to Life in India
        Relocating to India opens doors to rich cultural experiences and exciting opportunities, but it also
        comes with unique challenges. PG Overseas Services specializes in making your transition seamless,
        handling everything from finding the perfect home to setting up reliable support staff, allowing you
        to focus on embracing your new life in India.
        `,
    featuresTitle: "Our Settle in India Services Include:",
    features: [
      "Area Selection: Expert guidance on choosing the right neighborhood based on your preferences and needs",
      "Property Sourcing: Finding residential or commercial properties that match your requirements",
      "School Placement: Assistance with selecting and applying to appropriate educational institutions",
      "Staff Verification: Thorough background checks for household help, drivers, and security personnel",
      "Home Setup: Complete assistance with furnishing and equipping your new home",
      "Documentation Support: Help with local registrations, utilities, and administrative requirements",
      "Cultural Orientation: Practical guidance on local customs and practices",
    ],
    whyChooseTitle: "Why Choose Our Settle in India Services?",
    whyChoosePoints: [
      "Local Expertise: In-depth knowledge of different Indian cities and neighborhoods",
      "Verified Network: Access to pre-screened service providers and support staff",
      "Personalized Approach: Solutions tailored to your specific family or business needs",
      "Cultural Bridge: Assistance navigating cultural differences and local practices",
      "Ongoing Support: Continuous assistance beyond the initial settlement period",
    ],
    testimonial: {
      author: "David Thompson",
      designation: "Finance Director, Multinational Corporation",
      quote: `"Moving my family from London to Bangalore seemed overwhelming until we engaged PG Overseas
            Services. Their team found us a perfect home in an ideal neighborhood, secured spots for our
            children in an excellent international school, and arranged a reliable staff that was thoroughly vetted.
            Their cultural guidance helped us avoid common expat pitfalls, and their ongoing support made us
            feel at home within weeks rather than months."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Country of Residence*",
        type: "text",
        name: "currentCountry",
        required: true,
      },
      {
        label: "Target City in India*",
        type: "text",
        name: "targetCity",
        required: true,
      },
      {
        label: "Relocation Timeline*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Children's Ages (if applicable)*",
        type: "text",
        name: "childrenAges",
      },
      {
        label: "Housing Requirements*",
        type: "text",
        name: "housingRequirements",
        required: true,
      },
      {
        label: "School Requirements (if applicable)*",
        type: "text",
        name: "schoolRequirements",
      },
      { label: "Staff Requirements*", type: "text", name: "staffRequirements" },
      {
        label: "Special Considerations*",
        type: "text",
        name: "specialConsiderations",
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "work-abroad",
    seoTitle:
      "International Career Opportunities | Work Abroad Services | PG Overseas Services",
    metaDescription:
      "Expert guidance for professionals seeking international work opportunities. Discover the best career options worldwide with personalized consultation on countries, positions, and qualifications.",
    title: "Work Abroad",
    vdo: aboard,
    mainContent: `
        Elevate Your Career Globally
        In today's interconnected world, international work experience can significantly enhance your career
        trajectory and personal growth. PG Overseas Services specializes in helping professionals identify and
        secure the most valuable overseas opportunities aligned with their skills, aspirations, and lifestyle
        preferences.
        `,
    featuresTitle: "Our Work Abroad Services Include:",
    features: [
      "Career Opportunity Assessment: Evaluating your skills and experience for international marketability",
      "Country Selection Guidance: Identifying regions where your profession is in high demand",
      "Qualification Mapping: Understanding how your credentials transfer to different markets",
      "Job Market Intelligence: Providing insights on salary expectations and working conditions",
      "Application Strategy: Developing effective approaches for international job applications",
      "Interview Preparation: Specialized coaching for cross-cultural interview scenarios",
      "Visa and Work Permit Support: Guidance through employment authorization processes",
    ],
    whyChooseTitle: "Why Choose Our Work Abroad Services?",
    whyChoosePoints: [
      "Global Labor Market Expertise: Up-to-date knowledge of international hiring trends",
      "Industry-Specific Guidance: Specialized advice for your particular professional field",
      "Realistic Assessment: Honest evaluation of opportunities and challenges",
      "Cultural Preparation: Insights into workplace customs and expectations",
      "Long-term Career Planning: Strategies to leverage international experience for future growth",
    ],
    testimonial: {
      author: "Priya Narayan",
      designation: "Product Manager",
      quote: `"After 5 years in the same position, I was looking for new challenges but wasn't sure where to start.
            PG Overseas Services analyzed my skills and identified Singapore as an ideal market for my expertise
            in fintech. Their guidance on certification requirements, resume adaptation, and interview
            preparation was invaluable. Within three months, I secured a position that increased my
            compensation by 40% while opening doors to exciting new projects and technologies."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Profession/Industry*",
        type: "text",
        name: "profession",
        required: true,
      },
      {
        label: "Years of Experience*",
        type: "number",
        name: "experience",
        required: true,
      },
      {
        label: "Current Location*",
        type: "text",
        name: "location",
        required: true,
      },
      {
        label: "Preferred Destinations (if any)*",
        type: "text",
        name: "destinations",
      },
      {
        label: "Educational Qualifications*",
        type: "text",
        name: "education",
        required: true,
      },
      {
        label: "Language Proficiencies*",
        type: "text",
        name: "languages",
        required: true,
      },
      {
        label: "Career Objectives*",
        type: "textarea",
        name: "objectives",
        required: true,
      },
      {
        label: "Timeline for Relocation*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Resume/CV Upload*",
        type: "file",
        name: "resume",
        required: true,
      }, // Changed to file type.
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },
  {
    id: "property-management-services-in-india",
    seoTitle:
      "Property Management Services India | Absentee Owner Solutions | PG Overseas Services",
    metaDescription:
      "Comprehensive property management services in India. Expert maintenance, tenant management, and security solutions for overseas property owners.",
    title: "Property Management Services in India",
    vdo: property,
    mainContent: `
        Protect and Maximize Your Property Investment
        Managing property from overseas presents unique challenges that require specialized solutions. PG
        Overseas Services offers comprehensive property management services across India, ensuring your
        real estate investments remain secure, well-maintained, and financially productive, regardless of
        your location.
        `,
    featuresTitle: "Our Property Management Services Include:",
    features: [
      "Property Security: Regular inspections and security oversight",
      "Maintenance Coordination: Handling repairs and preventative maintenance",
      "Tenant Sourcing: Finding reliable, qualified tenants",
      "Rental Collection: Ensuring timely payment and proper financial recording",
      "Tenant Relationship Management: Professional handling of all tenant communications",
      "Legal Compliance: Ensuring adherence to local property regulations",
      "Financial Reporting: Regular updates on property income and expenses",
      "Tax Representation: Assistance with property-related tax matters",
    ],
    whyChooseTitle: "Why Choose Our Property Management Services?",
    whyChoosePoints: [
      "Peace of Mind: Complete oversight of your property while you're away",
      "Maximized Returns: Optimal rental pricing and minimal vacancy periods",
      "Quality Maintenance: Preservation of property value through proper upkeep",
      "Tenant Satisfaction: Professional management leading to longer tenancies",
      "Legal Protection: Ensuring all rental arrangements comply with local regulations",
      "Emergency Response: Immediate attention to urgent property issues",
    ],
    testimonial: {
      author: "Arun Desai",
      designation: "NRI Property Owner",
      quote: `"As an NRI with multiple properties in Mumbai, managing maintenance and tenants was becoming a
            full-time job. PG Overseas Services transformed this experience completely. Their team handles
            everything from finding quality tenants to overseeing repairs and collecting rent. Their transparent
            reporting keeps me informed without requiring my constant attention. Most importantly, their
            negotiation skills have increased my rental income by 15% while reducing tenant turnover."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Country of Residence*",
        type: "text",
        name: "currentCountry",
        required: true,
      },
      {
        label: "Property Location in India*",
        type: "text",
        name: "propertyLocation",
        required: true,
      },
      {
        label: "Property Type*",
        type: "text",
        name: "propertyType",
        required: true,
      },
      {
        label: "Current Property Status (Vacant, Rented, etc.)*",
        type: "text",
        name: "propertyStatus",
        required: true,
      },
      {
        label: "Services Required",
        type: "select",
        name: "servicesRequired",
        multiple: true, // Add multiple attribute
        options: [
          { label: "Property Security", value: 1 },
          { label: "Maintenance Coordination", value: 2 },
          { label: "Tenant Sourcing", value: 3 },
          { label: "Rental Collection", value: 4 },
          { label: "Tenant Relationship Management", value: 5 },
          { label: "Legal Compliance", value: 6 },
          { label: "Financial Reporting", value: 7 },
          { label: "Tax Representation", value: 8 },
        ],
        required: true,
      },
      {
        label: "Number of Properties*",
        type: "number",
        name: "numberOfProperties",
        required: true,
      },
      {
        label: "Specific Property Concerns*",
        type: "textarea",
        name: "concerns",
      },
      {
        label: "Management Timeline*",
        type: "text",
        name: "timeline",
        required: true,
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        required: true,
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
      },
    ],
  },

  {
    id: "medical-tourism-services",
    seoTitle:
      "Medical Tourism Services | International Healthcare Solutions | PG Overseas Services",
    metaDescription:
      "Access world-class healthcare at affordable prices. Expert guidance for medical tourism including treatment planning, hospital selection, travel arrangements, and post-care support.",
    title: "Medical Tourism/Overseas Healthcare",
    vdo: medi,
    mainContent: `
  Your Gateway to Global Healthcare Excellence
  Healthcare knows no borders, and neither should your access to world-class medical treatment. PG Overseas Services specializes in connecting patients with premier healthcare facilities worldwide, offering significant cost savings without compromising on quality. From complex surgeries to wellness treatments, we manage every aspect of your medical journey, ensuring you receive the best care with complete peace of mind.
  `,
    featuresTitle: "Our Medical Tourism Services Include:",
    features: [
      "Medical Consultation Matching: Connecting you with specialists in your required field",
      "Hospital & Clinic Selection: Recommending JCI-accredited and internationally recognized facilities",
      "Treatment Cost Analysis: Transparent pricing comparisons across different countries",
      "Medical Records Review: Facilitating communication between your home and destination doctors",
      "Medical Visa Assistance: Expedited visa processing for patients and companions",
      "Travel Planning: Flight bookings, airport transfers, and local transportation",
      "Hospital Liaison: Direct coordination with medical teams and administration",
      "Insurance Coordination: Assistance with international insurance claims",
      "Post-Treatment Follow-up: Arranging consultations and managing reports",
      "Rehabilitation Planning: Connecting with physiotherapy and recovery services",
    ],
    whyChooseTitle: "Why Choose Our Medical Tourism Services?",
    whyChoosePoints: [
      "Access to JCI-accredited hospitals and certified specialists",
      "Up to 80% savings on treatment costs compared to home countries",
      "Complete end-to-end management from visa to recovery",
      "Culturally sensitive care coordinators and multilingual support",
      "24/7 emergency support during your medical journey",
      "Legal protection and transparent communication",
    ],
    testimonial: {
      author: "Robert Chen",
      designation: "Retired Engineer, California",
      quote: `"When I was quoted $120,000 for hip replacement surgery in the US, I thought I'd have to live with the pain. PG Overseas Services arranged my treatment at a JCI-accredited hospital in India where I received exceptional care from a US-trained surgeon for just $8,000 total. The care quality exceeded my expectations, and their support made the entire experience stress-free. I'm now pain-free and saved enough to retire comfortably."`,
    },
    inquiryFormFields: [
      { label: "Full Name*", type: "text", name: "fullName", required: true },
      { label: "Email Address*", type: "email", name: "email", required: true },
      { label: "Phone Number*", type: "tel", name: "phone", required: true },
      {
        label: "Current Country of Residence*",
        type: "text",
        name: "currentCountry",
        required: true,
      },
      {
        label: "Medical Condition/Procedure Required*",
        type: "text",
        name: "medicalCondition",
        required: true,
      },
      {
        label: "Preferred Treatment Timeline*",
        type: "text",
        name: "treatmentTimeline",
        required: true,
      },
      {
        label: "Preferred Destination (if any)",
        type: "text",
        name: "preferredDestination",
      },
      {
        label: "Insurance Coverage Status",
        type: "text",
        name: "insuranceStatus",
      },
      {
        label: "Mobility Assistance Required",
        type: "select",
        name: "mobilityAssistance",
        options: [
          { label: "Yes", value: 1 },
          { label: "No", value: 0 },
        ],
        required: true,
      },
      {
        label: "Budget Range*",
        type: "text",
        name: "budgetRange",
        required: true,
      },
      {
        label: "Previous International Treatment Experience",
        type: "textarea",
        name: "previousExperience",
      },
      {
        label: "Special Medical Requirements",
        type: "textarea",
        name: "specialRequirements",
      },
      {
        label: "Preferred Contact Method*",
        type: "select",
        name: "contactMethod",
        options: [
          { label: "Email", value: 1 },
          { label: "Phone", value: 2 },
          { label: "WhatsApp", value: 3 },
        ],
        required: true,
      },
    ],
  },
];
